import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/other-income');
}
//Get all active
export function allActive(){
    return http().get('/other-income/active');
}
//Get Single
export function single(id){
    return http().get(`/other-income/${id}`);
}
//Add one
export function add(data){
    return http().post('/other-income', data)
}
//Update
export function update(id, data){
    return http().put(`/other-income/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/other-income/${id}`);
}